import { useMemo } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';

interface IModalContentPreference {
  hasError?: boolean;
  hasWarning?: boolean;
  hasInfo?: boolean;
  errorContent?: string[];
  warningContent?: string[];
  infoContent?: string[];
}

const ModalContentPreference = ({
  hasError = false,
  hasWarning = false,
  hasInfo = false,
  errorContent = [],
  warningContent = [],
  infoContent = [],
}: IModalContentPreference) => {
  const popUpContentHolder = useMemo(() => {
    if (hasError) return <PopUpContentWrapper type="Error" contents={errorContent} />;
    else if (hasWarning) return <PopUpContentWrapper type="Warning" contents={warningContent} />;
    else if (hasInfo) return <PopUpContentWrapper type="Information" contents={infoContent} />;
    else return <></>;
  }, [errorContent, hasError, hasInfo, hasWarning, infoContent, warningContent]);
  return <div className="m-1 max-w-[300px]">{popUpContentHolder}</div>;
};

export default ModalContentPreference;
